export default __webpack_public_path__ + "static/media/ico-key.d03dcff2.svg";